import { StyleSheet } from 'aphrodite';
import { colors, combineStyles, fonts, media, mixins } from 'consumer-components';

import * as deploymentConfig from '../../../../utils/deploymentConfig';

const progressBarBorder = 2;

const largeCircleRadius = 10;
const largeCircleSize = largeCircleRadius * 2;

const circleRadius = 5;
const circleLeft = largeCircleRadius + progressBarBorder / 2;

const greenCircleRadius = 13;
const greenCircleSize = greenCircleRadius * 2;
const greenCircleLeft = greenCircleRadius + progressBarBorder / 2;

const greenCircle = combineStyles(mixins.blIcon('\\e913'), mixins.border(3, 'solid', colors.white), {
  backgroundColor: colors.white,
  borderRadius: '50%',
  color: colors.grass,
  display: 'block',
  fontSize: 20,
  height: greenCircleSize,
  left: -1 * greenCircleLeft,
  position: 'absolute',
  top: -3,
  width: greenCircleSize,
});

const pinIcon = combineStyles(mixins.border(circleRadius, 'solid', colors.white), mixins.blIcon('\\e908'), {
  backgroundColor: colors.white,
  borderRadius: '50%',
  color: deploymentConfig.getOrganizationColors().action,
  display: 'block',
  fontSize: largeCircleSize,
  height: largeCircleSize + 12,
  left: -1 * circleLeft - 1.5,
  position: 'absolute',
  top: 0,
  width: largeCircleSize,
});

const progressCircle = combineStyles(mixins.border(circleRadius, 'solid', colors.white), {
  backgroundColor: colors.clayMinus2,
  borderRadius: '50%',
  content: mixins.pseudoContent(''),
  display: 'block',
  height: largeCircleSize,
  left: -1 * circleLeft,
  position: 'absolute',
  top: 1,
  width: largeCircleSize,
});

const styles = StyleSheet.create({
  wrapper: {
    ...fonts.Roboto,
    [media.mediumView]: {
      maxWidth: 550,
    },
  },
  errorWrapper: {
    paddingBottom: 20,
  },
  bulletWrapper: {
    padding: '0 3%',
    [media.mediumView]: {
      padding: 0,
    },
  },
  introDetails: {
    color: colors.grass,
    paddingLeft: 3,
  },
  introDetailsWrapper: combineStyles(mixins.borderLeft(progressBarBorder, 'solid', colors.grass), {
    position: 'relative',
    ':before': greenCircle,
  }),
  heading: {
    color: colors.clayPlus3,
    fontSize: 10,
    fontWeight: fonts.weight.bold,
    letterSpacing: 2,
    paddingBottom: 3,
    paddingLeft: 3,
    textTransform: 'uppercase',
    [media.mediumView]: {
      fontSize: 11,
      paddingBottom: 5,
    },
  },
  stepWrapperPaddingLeft: {
    paddingLeft: 20,
    [media.mediumView]: {
      paddingLeft: 24,
    },
    [media.largeView]: {
      paddingLeft: 38,
    },
  },
  stepWrapperPaddingBottom: {
    paddingBottom: 32,
    [media.mediumView]: {
      paddingBottom: 45,
    },
  },
  stepWrapper: combineStyles(mixins.borderLeft(progressBarBorder, 'solid', colors.clayMinus2), {
    position: 'relative',
    ':before': progressCircle,
    ':last-child': {
      borderLeft: 'none',
      ':before': {
        // the last child has no border
        left: -1 * (circleLeft - progressBarBorder),
      },
    },
  }),
  stepWrapperFirstChild: {
    ':first-child': {
      ':before': pinIcon,
    },
  },
  titleWrapper: {
    display: 'flex',
  },
  title: {
    color: colors.darkerGray,
    fontWeight: fonts.weight.bold,
    fontSize: 18,
    [media.mediumView]: {
      fontSize: 24,
    },
  },
  notFirstTitle: {
    fontSize: 18,
    [media.mediumView]: {
      fontSize: 18,
    },
  },
  time: {
    color: colors.clayPlus3,
    fontSize: 10,
    fontWeight: fonts.weight.medium,
    lineHeight: '24px',
    marginLeft: 'auto',
    whiteSpace: 'nowrap',
    [media.mediumView]: {
      fontSize: 12,
    },
  },
  notFirstTime: {
    lineHeight: '18px',
  },
  description: {
    color: colors.clayPlus3,
    fontSize: 14,
    fontWeight: fonts.weight.regular,
    lineHeight: 1.4,
    paddingTop: 5,
  },
  buttonWrapper: {
    [media.smallView]: {
      width: 190,
    },
    [media.mediumView]: {
      width: 190,
    },
    [media.mobileMedium]: {
      width: '100%',
    },
  },
  contextLink: {
    textDecoration: 'none',
  },
});

export default styles;
